<template>
	
<div class="sectionh" :class="{'is-complete': completed}" v-on:click.stop="onExpandClick">

	<div class="sectionh-title">

		{{ title }}

		<div class="sectionh-title-complete" v-if="completed"><span>Re-open</span></div>

	</div>

	<div class="sectionh-content" :class="{'is-row': row}" v-if="active">

		<slot></slot>
 
	</div>

	<div class="sectionh-foot" v-if="active">

		<div class="sectionh-foot-instruction" v-if="instruction">{{ instruction }}</div>
		
		<com-next v-if="!completed" v-on:click.native.stop="$emit('next')" :right="true" :dark="true" :down="true" class="sectionh-next" />

	</div>

</div>

</template>

<script>

import comNext from './../common/Next'

export default {

	props: ['title', 'completed', 'active', 'row', 'instruction'],

	components: {
		'com-next': comNext
	},

	methods: {

		onExpandClick: function() {

			this.$emit('back')

		}

	}
	
}

</script>

<style scoped>

.sectionh {
	background: #f6f6f6;
	border-radius: 32px;
	padding: 16px 32px;
	margin-bottom: 16px;
	user-select: none;
}

.sectionh.is-complete:hover {
	cursor: pointer;
	background: #eee;
}

.sectionh-title {
	color: #343434;
	font-size: 20px;
	font-weight: 600;
}

.sectionh-title-complete {
	width: 36px;
	height: 36px;
	border-radius: 18px;
	background-color: #F8A533;
	background-image: url(~@/assets/aid/common/icon.tick.svg);
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: absolute;
	right: 0px;
	top: -8px;
}

.sectionh-title-complete span {
	display: block;
	position: absolute;
	right: 40px;
	line-height: 36px;
	white-space: nowrap;
	font-size: 12px;
    letter-spacing: 1px;
    font-weight: bold;
    text-transform: uppercase;
    margin-right: 12px;
	color: #343434;
}

.sectionh-content {
	padding: 16px 0px 0px 0px;
	display: flex;
	flex-direction: column;
}

.sectionh-content.is-row {
	flex-direction: row;
}

.sectionh-foot {
	padding-top: 16px;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	flex-shrink: 0;
	position: sticky;
	bottom: 16px;
	z-index: 10;
}

.sectionh-foot-instruction {
	flex-grow: 1;
	color: #343434;
	letter-spacing: 1px;
	font-weight: 600;
	text-transform: uppercase;
	font-size: 12px;
}

</style>